import { createContext } from 'react';

export const ContactInfoFormContext = createContext<any>(null);

const ContactInfoContextProvider = (props: any = {}) => {
  const { children, formHandlerObject, zipCode, contactEmailDomainsList } = props;
  const contactInfoFormContextValue = {
    ...formHandlerObject,
    ...(zipCode !== undefined ? { zipCode } : {}),
    ...(contactEmailDomainsList !== undefined ? { contactEmailDomainsList } : {}),
  };
  return (
    <ContactInfoFormContext.Provider
      value={{
        ...contactInfoFormContextValue,
        ...props?.formHandlerObject,
        userToggleableSmsFieldNames: props?.userToggleableSmsFieldNames,
      }}
    >
      {children}
    </ContactInfoFormContext.Provider>
  );
};
export default ContactInfoContextProvider;
